import { useSyncEnvironmentToWindow } from '@/hooks/environment/useSyncEnvironmentToWindow';

export const WindowEnvironmentProvider = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  useSyncEnvironmentToWindow();

  return <>{children}</>;
};
